export { default as Img200 } from './processed/200/Veep-S1.jpg';
export { default as Img400 } from './processed/400/Veep-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Veep-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Veep-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Veep-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      200,
      36,
      46
    ],
    "_population": 2671,
    "_hsl": [
      0.9898373983739838,
      0.6949152542372881,
      0.4627450980392157
    ]
  },
  "LightVibrant": {
    "_rgb": [
      211,
      178,
      148
    ],
    "_population": 829,
    "_hsl": [
      0.07936507936507935,
      0.4172185430463574,
      0.7039215686274509
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      21,
      70,
      114
    ],
    "_population": 920,
    "_hsl": [
      0.578853046594982,
      0.688888888888889,
      0.2647058823529412
    ]
  },
  "Muted": {
    "_rgb": [
      166,
      115,
      93
    ],
    "_population": 357,
    "_hsl": [
      0.05022831050228311,
      0.2908366533864542,
      0.5078431372549019
    ]
  },
  "LightMuted": {
    "_rgb": [
      207,
      195,
      178
    ],
    "_population": 1518,
    "_hsl": [
      0.09770114942528729,
      0.23200000000000007,
      0.7549019607843137
    ]
  },
  "DarkMuted": {
    "_rgb": [
      77,
      47,
      40
    ],
    "_population": 1105,
    "_hsl": [
      0.03153153153153155,
      0.3162393162393162,
      0.22941176470588234
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Veep-S1.js